import React, { useEffect } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { getFormValues, change } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { REDUCER_NAME } from 'src/reducers/clients/semiMonthlyPayment';
import { PAYROLL_RULES_GROUP_FORM } from 'src/constants/FormNames';
import { ArrowBold } from 'jbc-front/components/icons';
import { getItem, setItem } from 'src/reducers/common/itemReducer';
import { HYPHEN_CHARACTER } from 'src/constants/Generals';

import { PreviewContainer, Container, Box, DateBox } from '../styles';
import { calculateDateForPreview, DATE_PATTERN } from '../utils';

const SemiMonthlyPreview = props => {
  const { i18n, t } = useTranslation();
  moment.locale(i18n.language);
  const { dispatch, semiMonthlyPayment, firstHalfStartDate, closingDay, paymentDay, paymentDaySecondHalf, paymentMonthType } = props;
  const endOfMonth = moment('8', 'M')
    .endOf('month')
    .get('D');
  const validateDate = date => (date?.isValid() ? date.format(DATE_PATTERN) : HYPHEN_CHARACTER);

  useEffect(
    () => {
      if (!props.showOnModal && props.paymentCount === 'twice') {
        const calculatedDate = calculateDateForPreview(props, i18n);
        dispatch(change(PAYROLL_RULES_GROUP_FORM, 'secondHalfStartDate', closingDay + 1 > endOfMonth ? 1 : closingDay + 1));
        dispatch(setItem(REDUCER_NAME, calculatedDate));
      }
    },
    [closingDay, firstHalfStartDate, paymentDay, paymentDaySecondHalf, paymentMonthType]
  );

  const { firstHalf, secondHalf } = semiMonthlyPayment || {};
  return (
    <PreviewContainer>
      <h3>{t(`features.PayrollRulesGroups.containers.PayrollRulesGroupForm.${props.title}`)}</h3>
      <Container>
        <Box>
          <h4>{t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.first_half')}</h4>
          <DateBox showOnModal={props.showOnModal}>
            {t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.start')}
            <span>{validateDate(firstHalf?.startDate)}</span>
          </DateBox>
          <span>～</span>
          <DateBox showOnModal={props.showOnModal}>
            {t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.end')}
            <span>{validateDate(firstHalf?.endDate)}</span>
          </DateBox>
          <ArrowBold size={13} />
          <DateBox>
            {t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.payment_date')}
            <span>{validateDate(firstHalf?.paymentDate)}</span>
          </DateBox>
        </Box>
        <Box>
          <h4>{t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.second_half')}</h4>
          <DateBox showOnModal={props.showOnModal}>
            {t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.start')}
            <span>{validateDate(secondHalf?.startDate)}</span>
          </DateBox>
          <span>～</span>
          <DateBox showOnModal={props.showOnModal}>
            {t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.end')}
            <span>{validateDate(secondHalf?.endDate)}</span>
          </DateBox>
          <ArrowBold size={13} />
          <DateBox>
            {t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.payment_date')}
            <span>{validateDate(secondHalf?.paymentDate)}</span>
          </DateBox>
        </Box>
      </Container>
    </PreviewContainer>
  );
};

const mapStateToProps = state => ({
  paymentDay: getFormValues(PAYROLL_RULES_GROUP_FORM)(state)?.paymentDay,
  closingDay: getFormValues(PAYROLL_RULES_GROUP_FORM)(state)?.closingDay,
  closingDaySecondHalf: getFormValues(PAYROLL_RULES_GROUP_FORM)(state)?.closingDaySecondHalf,
  paymentMonthType: getFormValues(PAYROLL_RULES_GROUP_FORM)(state)?.paymentMonthType,
  paymentDaySecondHalf: getFormValues(PAYROLL_RULES_GROUP_FORM)(state)?.paymentDaySecondHalf,
  firstHalfStartDate: getFormValues(PAYROLL_RULES_GROUP_FORM)(state)?.firstHalfStartDate,
  semiMonthlyPayment: getItem(REDUCER_NAME, state) || {},
  paymentCount: getFormValues(PAYROLL_RULES_GROUP_FORM)(state)?.paymentCount
});

export default connect(mapStateToProps)(SemiMonthlyPreview);
